import React from 'react'
import {Helmet} from 'react-helmet';
import BeProjects from './Components/BeProjects';
import ProjectHead from '../../Components/Head/projecthead';
import BeHead from '../../Components/Head/BeHead';
import { Outlet } from 'react-router-dom';


function BeProjectsWrapper() {
  return (
    <>
        {/* <Helmet>
          <title>Yash Admin Sales Management System</title>                                                                                                                                                                                                                                 
        </Helmet> */}
        <div>
            {/* <ProjectHead /> */}
            {/* <BeHead />
            <BeProjects /> */}
            <Outlet />
        </div>
    </>
  )
}

export default BeProjectsWrapper;